import { Avatar, Grid, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import * as api from "api/Knowledge";
import { DefaultListParameters } from 'assets/appConfig';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import BoxDrawer from 'components/BoxDrawer';
import { SpinnerIndicator } from 'components/CallServer';
import MuiPagination from 'components/MuiExtras/MuiPagination';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { PagedResult, UserShortView } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    data: PagedResult<UserShortView>;
    loading: boolean;
    offset: number;
}

interface IProps {
    topicId: string;
    onClose: () => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class TopicFollowersDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            data: null,
            loading: false,
            offset: 0
        };
    }

    ///
    private loadData(offset: number) {

        this.setState({ loading: true, data: null });

        api.getTopicFollowers(this.props.topicId, offset, DefaultListParameters.drawerRecordsByPage)
            .then((result) => {
                this.setState({ loading: false, data: result, offset: this.state.offset });
            })
            .catch((error) => {
                this.setState({ loading: false, offset: 0 });
            });
    }

    ///
    public componentDidMount() {
        this.loadData(0);
    }

    ///
    public render() {
        const { onClose } = this.props;
        const { data, loading, offset } = this.state;
        return (
            <BoxDrawer
                open
                overflow="hidden"
                onClose={onClose}
                title={this.props.t("Views.Topic.Dialogs.TopicFollowersDrawer.BoxTitle")}
            >
                <MuiPaper dense fullHeight elevation={0}>
                    <Grid container direction="column" wrap="nowrap" style={{ height: "100%" }}>

                        <Grid item className={GlobalClassKeys.grow}>

                            {loading
                                ? <SpinnerIndicator />
                                : data && data.total > 0
                                    ? <List dense disablePadding>
                                        {
                                            data.items.map((v, index) => {
                                                return (
                                                    <ListItem key={index} disableGutters>
                                                        <ListItemAvatar>
                                                            <Avatar src={v.thumbnailUrl} />
                                                        </ListItemAvatar>
                                                        <ListItemText primary={v.name} primaryTypographyProps={{ noWrap: true }} />
                                                    </ListItem>
                                                );
                                            })
                                        }
                                    </List>
                                    : null
                            }
                        </Grid>

                        {
                            !loading && data && data.total > 0 &&
                            <Grid item>
                                <MuiPagination
                                    limit={DefaultListParameters.drawerRecordsByPage}
                                    offset={offset}
                                    total={data.total}
                                    onClick={(e, offset) => this.loadData(offset)}
                                />
                            </Grid>
                        }
                    </Grid>
                </MuiPaper>

            </BoxDrawer>
        );
    }
}

export default withTranslation()(TopicFollowersDrawer);